import { useState, type FormEvent } from 'react';
import { useAuth } from './AuthContext';
import { LogoMark } from '../components/icons/LogoMark';
import './login.css';

// Mirrors design/hub/login.html's credential form (inline validation against
// Authentik's Flow Executor, no redirect-to-a-second-page) but as a React
// component. Visual styling is a simplified, non-branded variant — the hub's
// own photography/logo assets aren't duplicated here.
export function LoginPage() {
  const { login, error } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setLoading(true);
    try {
      await login({ email, password });
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-card">
      <div className="login-panel">
        <LogoMark size={44} className="login-logo" />
        <div className="login-eyebrow">Abrar Farms Maps</div>
        <h1 className="login-title">Sign in</h1>
        <form onSubmit={onSubmit}>
          <label className="sr-only" htmlFor="af-email">Email or username</label>
          <div className="field">
            <input
              id="af-email"
              type="text"
              placeholder="Email or username"
              autoCapitalize="off"
              autoCorrect="off"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <label className="sr-only" htmlFor="af-password">Password</label>
          <div className="field">
            <input
              id="af-password"
              type={showPassword ? 'text' : 'password'}
              placeholder="Your password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              type="button"
              className="eye-btn"
              aria-label={showPassword ? 'Hide password' : 'Show password'}
              onClick={() => setShowPassword((v) => !v)}
            >
              {showPassword ? 'Hide' : 'Show'}
            </button>
          </div>
          {error && (
            <div className="form-error" role="alert">
              {error}
            </div>
          )}
          <button type="submit" className="btn" disabled={loading}>
            {loading ? 'Checking…' : 'Continue'}
          </button>
        </form>
      </div>
    </div>
  );
}
